import React from 'react';
import { SwiperSlide } from 'swiper/react';
import { brandCardTypes } from '@/constants/types';
import SliderWrapper from '../Wrapper/SliderWrapper';
import BrandCardDesktop from '../Card/BrandCardDesktop';

// swiper slider
import 'swiper/css';
import 'swiper/css/scrollbar';

function OtherBrandsSlider({ data = [] }) {
  return (
    <SliderWrapper data={data}>
      {Array.isArray(data) && data?.length > 0
        ? data?.map((brand, index) => (
            <SwiperSlide
              key={brand?.id ?? index}
              className="!w-max !flex !justify-center xl:!justify-start"
            >
              <BrandCardDesktop
                key={brand.slug}
                brand={brand}
                type={brandCardTypes.other}
              />
            </SwiperSlide>
          ))
        : null}
    </SliderWrapper>
  );
}

export default OtherBrandsSlider;
